import * as Sentry from "@sentry/react";
import type { User } from "../dtos/Tmd.dtos";
import { createSentryAnonymousUser } from "./errors";

let currentUser: User | undefined;

export function applyAuthenticationIdentity(): void {
    Sentry.setUser(currentUser?.userName ? {
        id: currentUser.userName,
        username: currentUser.userName,
        fullName: currentUser.fullName,
        email: currentUser.email,
        authenticated: true,
    } : createSentryAnonymousUser());
}

export function setAuthenticationIdentity(user?: User): void {
    currentUser = user;
    applyAuthenticationIdentity();
}
